import {useEffect, useState} from "react";
import LegalbirdLoader from "../ContentLoader/LegalbirdLoader";
import {Divider, Grid, Paper, Typography} from "@mui/material";
import dayjs from "dayjs";
import {
  fetchReleaseUpdateMediaObjects,
  fetchReleaseUpdatePublications,
  getReleaseUpdateMediaObjectIds,
  RELEASE_UPDATE_PUBLICATIONS_PER_PAGE,
} from "../../services/releaseUpdateService";
import {useQuery} from "@tanstack/react-query";
import ReleaseUpdateContent from "./ReleaseUpdateContent";
import releaseUpdateStyles from "./releaseUpdatesStyles";
import {useSnackbar} from "notistack";
import { useCurrentUser } from "../../provider/CurrentUserProvider";
import PagePagination from "../PagePagination/PagePagination";

export default function ReleaseUpdates() {
  const [page, setPage] = useState(1);
  const { enqueueSnackbar } = useSnackbar();
  const currentUser = useCurrentUser();
  const {
    data: publicationResult,
    isError,
    isLoading,
  } = useQuery({
    queryKey: ["releaseUpdateArchivePublications", currentUser.isExternal, page],
    queryFn: () => fetchReleaseUpdatePublications(currentUser.isExternal, page),
  });
  const publications = publicationResult?.["hydra:member"] ?? [];
  const totalPages = Math.ceil(
    (publicationResult?.["hydra:totalItems"] ?? 0) / RELEASE_UPDATE_PUBLICATIONS_PER_PAGE,
  );
  const mediaObjectIds = getReleaseUpdateMediaObjectIds(publications);
  const { data: mediaObjects = [] } = useQuery({
    queryKey: ["releaseUpdateArchiveMediaObjects", mediaObjectIds],
    queryFn: () => fetchReleaseUpdateMediaObjects(mediaObjectIds),
  });

  useEffect(() => {
    if (isError) {
      enqueueSnackbar("Die Release-Updates konnten nicht geladen werden.", { variant: "error" });
    }
  }, [isError, enqueueSnackbar]);

  if (isLoading) {
    return <LegalbirdLoader centered />;
  }

  return (
    <>
      {publications.length === 0 && (
        <Typography sx={{ textAlign: "center" }}>Es gibt noch keine Release-Updates.</Typography>
      )}
      {publications.map((publication) => (
        <Paper key={publication.id} sx={releaseUpdateStyles.archivePaper}>
          <Typography variant="h2" sx={{ marginBottom: "1.5rem" }}>
            Release-Update vom {dayjs(publication.publishedAt ?? publication.created).format("DD.MM.YYYY")}
          </Typography>
          {publication.messages.map((message, index) => (
            <section key={message.id}>
              {index > 0 && <Divider sx={{ marginY: "2rem" }} />}
              <ReleaseUpdateContent
                message={message}
                publishedAt={publication.publishedAt}
                mediaObjects={mediaObjects}
              />
            </section>
          ))}
        </Paper>
      ))}
      {totalPages > 1 && (
        <Grid container sx={{ justifyContent: "flex-end" }}>
          <PagePagination
            currentPage={page}
            totalPages={totalPages}
            handlePrevPage={() => setPage((currentPage) => currentPage - 1)}
            handleNextPage={() => setPage((currentPage) => currentPage + 1)}
          />
        </Grid>
      )}
    </>
  );
}
